import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { parseEvidenceHref, resolveEvidence } from '../evidenceLinks';
import { formatClock } from '../replayPlayerState';

/**
 * Renders markdown where Evidence Links resolve to seek controls.
 * Unresolved evidence:… links are dropped (plain text, no clickable time).
 * Ordinary http(s) links are left alone.
 */
const EvidenceMarkdown = ({ markdown, evidenceIndex, onSeek }) => {
  const components = {
    a: ({ href, children }) => {
      const id = parseEvidenceHref(href);
      if (id == null) {
        return <a href={href}>{children}</a>;
      }
      const ref = resolveEvidence(evidenceIndex, id);
      if (!ref) {
        // Drop the seek control — keep any label as inert text (scenario 4.6).
        return <span data-testid="evidence-unresolved">{children}</span>;
      }
      const label =
        children && String(children).trim() !== ''
          ? children
          : formatClock(ref.start);
      return (
        <button
          type="button"
          className="evidence-link"
          data-testid="evidence-link"
          data-evidence-id={ref.id}
          onClick={() => onSeek?.(ref.start)}
        >
          {label}
        </button>
      );
    },
  };

  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>
      {markdown || ''}
    </ReactMarkdown>
  );
};

export default EvidenceMarkdown;
